const Heading = ({ text, paratext, text2 }) => {
    return (
        <>
            <h1 className="font-bold text-5xl xl:text-6xl textblack capitalize textblack">{text}</h1>
            <h1 class="mt-4 font-semibold text-lg textblack">{text2}</h1>
            <p class="my-4 font-medium text-lg textblack">{paratext}</p>
        </>

    );
};

export default Heading;